



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { IAlertModel } from '@/entities';
import { mapGetters } from 'vuex';
import { UIAlertInfo } from '@/store/modules/alert';

import * as types from '@/store/types';

@Component({
    computed: mapGetters({
        alert: types.ALERT_GET_UI_INFO
    })
})
export default class AlertContainer extends Vue {
    public loading: boolean = false;

    public alert: UIAlertInfo;

    get visible(): boolean {
        return this.alert.visible;
    }

    public markAsRead() {
        this.close();
    }

    // public submit() {
    //     this.loading = true;
    //     this.confirm.afterFn(() => {
    //         this.loading = false;
    //         this.close();
    //     });
    // }

    // public overlayClick($event) {
    //     if (
    //         $event.target.classList.contains('overlay_class_simulate_outside')
    //     ) {
    //         this.cancel();
    //     }
    // }

    public close() {
        this.$store.dispatch(types.ALERT_MARK_AS_READ);
    }
}
